import { useState } from "react";
import { TextField, Button, Grid } from "@mui/material";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase/config";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "contacts"), {
        ...formData,
        timestamp: new Date(),
      }).then((docRef) => {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      });
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <div style={{ width: "100%" }}>
          <input
            type="text"
            placeholder="Tên bạn"
            className="w-full border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary_blue"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
        </div>
        <div style={{ width: "100%" }}>
          <input
            type="email"
            placeholder="Email*"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            required
            className="w-full border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary_blue"
          />
        </div>
        <div style={{ width: "100%" }}>
          <textarea
            rows={4}
            required
            placeholder="Nội dung tin nhắn"
            className="w-full border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary_blue"
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
          ></textarea>
        </div>
        <div style={{ width: "100%" }}>
          <button
            type="submit"
            className="bg-primary_blue text-white text-sm font-medium px-6 py-3 rounded-lg hover:bg-primary_blue transition"
          >
            Gửi tin nhắn
          </button>
        </div>
      </Grid>
    </form>
  );
};
export default ContactForm;
